const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="relative min-h-screen">
      <img 
        src="https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=1600&auto=format&fit=crop" 
        alt="bg" 
        className="object-cover absolute inset-0 w-full h-full" 
      />
      <div className="absolute inset-0 bg-black/60" />
      <div className="flex relative z-10 justify-center items-start pt-10">
        <img 
          src="/images/logo_navbar.png" 
          alt="TripSecure Admin" 
          className="h-10" 
        />
      </div>
      <div className="flex relative z-10 justify-center items-center p-6">
        <div className="p-6 mt-4 w-full max-w-md rounded-3xl shadow-2xl bg-white/95">
          <h2 className="text-lg font-semibold text-center">{title}</h2>
          {subtitle && (
            <p className="mt-1 text-xs text-center text-gray-500">{subtitle}</p>
          )}
          <div className="mt-5 space-y-4">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
